// SimpleForms
import AtenObstForm from '../views/simpleForms/AtenObstForm.vue'
import AtencionForm from '../views/simpleForms/AtencionForm.vue'
import BitacoraForm from '../views/simpleForms/BitacoraForm.vue'
import CitaForm from '../views/simpleForms/CitaForm.vue'
import EmpresaForm from '../views/simpleForms/EmpresaForm.vue'
import FacturaForm from '../views/simpleForms/FacturaForm.vue'
import InterconsultaDestinoForm from '../views/simpleForms/InterconsultaDestinoForm.vue'
import InterconsultaForm from '../views/simpleForms/InterconsultaForm.vue'
import MedicoForm from '../views/simpleForms/MedicoForm.vue'
import PersonaForm from '../views/simpleForms/PersonaForm.vue'
import SuscripcionForm from '../views/simpleForms/SuscripcionForm.vue'
import TratamientoForm from '../views/simpleForms/TratamientoForm.vue'
import UsuarioForm from '../views/simpleForms/UsuarioForm.vue'
import UsuarioResumenForm from '../views/simpleForms/UsuarioResumenForm.vue'

export default [
  {
    path: '/atenobstform/:p_idatencion/:p_numero/:p_estadoatencion',
    name: 'AtenObstForm',
    component: AtenObstForm
  },
  {
    path: '/atencionform/:p_idatencion',
    name: 'AtencionForm',
    component: AtencionForm
  },
  {
    path: '/bitacoraform/:p_idpersona/:p_nombre',
    name: 'BitacoraForm',
    component: BitacoraForm
  },
  {
    path: '/citaform',
    name: 'CitaForm',
    component: CitaForm
  },
  {
    path: '/empresaform/:p_idempresa',
    name: 'EmpresaForm',
    component: EmpresaForm
  },
  {
//    path: '/facturaform/:p_idfactura',
    path: '/facturaform',
    name: 'FacturaForm',
    component: FacturaForm
  },
  {
    path: '/interconsultadestinoform/:p_numero_atencion/:p_idinterconsulta',
    name: 'InterconsultaDestinoForm',
    component: InterconsultaDestinoForm
  },
  {
    path: '/interconsultaform/:p_opcion/:p_numero_atencion/:p_idinterconsulta',
    name: 'InterconsultaForm',
    component: InterconsultaForm
  },
  {
    path: '/medicoform/:p_idmedico',
    name: 'MedicoForm',
    component: MedicoForm
  },
  {
    path: '/personaform/:p_pagina/:p_idpersona',
    name: 'PersonaForm',
    component: PersonaForm,
    props: true
  },
  {
    path: '/suscripcionform/:p_idsuscripcion',
    name: 'SuscripcionForm',
    component: SuscripcionForm
  },
  {
    path: '/tratamientoform',
    name: 'TratamientoForm',
    component: TratamientoForm
  },
  {
    path: '/usuarioform/:p_idusuario',
    name: 'UsuarioForm',
    component: UsuarioForm
  },
  {
    path: '/usuarioresumenform/:p_idusuario',
    name: 'UsuarioResumenForm',
    component: UsuarioResumenForm
  },
  {
    path: '/interconsultaorigenform/:p_numeroAtencion/:p_estadoAtencion/:p_idInterconsulta',
    name: 'InterconsultaOrigenForm',
    component: () => import('../views/simpleForms/InterconsultaOrigenForm.vue'),
    props: (route) => ({
      p_numeroAtencion:  route.params.p_numeroAtencion,
      p_estadoAtencion:  route.params.p_estadoAtencion,
      p_idInterconsulta: Number(route.params.p_idInterconsulta),
    })
  },
  {
    path: '/referenciaform/:p_idAtencion/:p_numeroAtencion/:p_idReferencia/:p_estadoAtencion/:p_pagina',
    name: 'ReferenciaForm',
    component: () => import('../views/simpleForms/ReferenciaForm.vue'),
    props: (route) => ({
      p_idAtencion:     Number(route.params.p_idAtencion),
      p_numeroAtencion: route.params.p_numeroAtencion,
      p_idReferencia:   Number(route.params.p_idReferencia),
      p_estadoAtencion: route.params.p_estadoAtencion,
      p_pagina:         route.params.p_pagina,
    })
  },
];
